import { render, staticRenderFns } from "./myIssue.vue?vue&type=template&id=5afb20f4&scoped=true&"
import script from "./myIssue.vue?vue&type=script&lang=js&"
export * from "./myIssue.vue?vue&type=script&lang=js&"
import style0 from "./myIssue.vue?vue&type=style&index=0&id=5afb20f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb20f4",
  null
  
)

export default component.exports